define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 面编辑模式。
     *
     * @exports EnumPathEditMode
     * 
     * @see Polygon#editMode
     */
    var EnumPathEditMode = {
        /**
         * 展示模式。
         * @type {String}
         * @constant
         */
        SHOW: "SHOW",

        /**
         * 编辑模式。
         * @type {String}
         * @constant
         */
        EDIT: "EDIT"
    }
    freezeObject(EnumPathEditMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {String} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumPathEditMode) {
            if (EnumPathEditMode.hasOwnProperty(key) && EnumPathEditMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        SHOW: "SHOW",
        EDIT: "EDIT",
        getName: getName
    }
})